module.exports = __webpack_public_path__ + "static/the-sympathizer-e52d7a592313cff60e2603d502027128.jpg";